import { Route, Routes, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/auth-provider';
import { guardNavigate } from '../helpers/navigation-guard';
import { Export } from './TicketsAdmin/Export';
import { Orders } from './TicketsAdmin/Orders';
import { Files } from './TicketsAdmin/Files';
import { ConcertSeriesWorkbench } from './ConcertsAdmin/ConcertSeriesWorkbench';
import { PlanEditor } from './PlansAdmin/PlanEditor';
import { PlaylistsAdmin } from './PlaylistsAdmin';
import { LocationsWorkbench } from './LocationsAdmin/LocationsWorkbench';
import { FullWidthPage } from '../components/FullWidthPage';

export const Admin = () => {
    const { profile, hasRole } = useAuth();
    const location = useLocation();

    const isConcertSeries = location.pathname.startsWith('/admin/concert-series');
    const isLocations = location.pathname.startsWith('/admin/locations');
    const isPlanEditor = location.pathname.startsWith('/admin/plan-editor');
    const isPayment = location.pathname.startsWith('/admin/orders');
    const isExport = location.pathname.startsWith('/admin/export');
    const isPlaylists = location.pathname.startsWith('/admin/playlists');

    const tabsContainerStyle: React.CSSProperties = {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'stretch',
        flexWrap: 'wrap',
        width: '980px',
        maxWidth: '100%',
        margin: '0 auto',
    };

    const clearRowStyle: React.CSSProperties = { width: '100%', flexBasis: '100%' };

    const renderAdminTab = (path: string, label: string, isActive: boolean) => (
        <a
            href={path}
            title={label}
            style={{
                backgroundColor: isActive ? 'white' : 'inherit',
                color: isActive ? 'black' : 'inherit',
            }}
            onClick={(event) => {
                event.preventDefault();
                guardNavigate(path);
            }}
        >
            {label}
        </a>
    );

    return (
        <FullWidthPage>
            <div style={tabsContainerStyle}>
                <div className="menutop_main">
                    {renderAdminTab('/admin/concert-series', 'Konzerte', isConcertSeries)}
                </div>
                <div className="menutop_main">{renderAdminTab('/admin/locations', 'Konzertlokale', isLocations)}</div>
                <div className="menutop_main">{renderAdminTab('/admin/plan-editor', 'Sitzplaene', isPlanEditor)}</div>
                <div className="menutop_main">{renderAdminTab('/admin/orders', 'Reservationen', isPayment)}</div>
                <div className="menutop_main">{renderAdminTab('/admin/export', 'Reservations Export', isExport)}</div>
                <div className="menutop_main">{renderAdminTab('/admin/playlists', 'Playlists', isPlaylists)}</div>
                <div style={clearRowStyle}></div>
            </div>
            {hasRole(profile, 'admin') ? (
                <Routes>
                    <Route path="export" element={<Export />} />
                    <Route path="orders" element={<Orders />} />
                    <Route path="concert-series" element={<ConcertSeriesWorkbench />} />
                    <Route path="concert-series/:seriesId" element={<ConcertSeriesWorkbench />} />
                    <Route path="concert-series/:seriesId/concert/:concertId" element={<ConcertSeriesWorkbench />} />
                    <Route path="files" element={<Files />} />
                    <Route path="playlists" element={<PlaylistsAdmin />} />
                    <Route path="locations" element={<LocationsWorkbench />} />
                    <Route path="locations/:locationId" element={<LocationsWorkbench />} />
                    <Route path="plan-editor" element={<PlanEditor />} />
                    <Route path="plan-editor/:planId" element={<PlanEditor />} />
                </Routes>
            ) : (
                <div>
                    <h1 style={{ paddingTop: 100 }}>No Access! Please login!</h1>
                </div>
            )}
        </FullWidthPage>
    );
};

export default Admin;
